import React, { useRef, useState } from "react";
import "./PhotographerCard.css";

// img
import avatarImg from "../../../assets/png/avatar.png";

// Jds
import { Notifications, ActionButton, Text, Tooltip } from "@jds/core";

// Mui
import { Box, Button, IconButton } from "@mui/material";
import {
  Edit2,
  Mail,
  Phone,
  UserCheck,
  UserX,
} from "lucide-react";
import { addParamsURL, downloadFile } from "../../../util/helper";
import useApiHttp from "../../../hooks/use-http";
import decryptUrl from "../../../util/img-decryption";
import JdsModal from "../JdsModal";

export default function PhotographerCard(props) {
  const [isBlockModalClose, setBlockModalClose] = useState(true);
  const data = props?.data || {};
  const id = data?.id;
  const profilePic = data?.profilePictureThumbnailUrl
    ? data?.profilePictureThumbnailUrl
    : null;
  const status = data?.registerStatus || "NULL";
  const isDenied = status === "DENIED";
  const isBlocked = data?.isBlocked;
  const firstName = data.firstName || "";
  const lastName = data.lastName || "";
  const guestName = `${firstName} ${lastName}`.trim() || "Unnamed";
  const contactNum = data?.phoneNumber;
  const avatarUrl = data?.profileFile
    ? URL.createObjectURL(data?.profileFile)
    : profilePic
      ? addParamsURL(profilePic, { size: "s" })
      : avatarImg;

  const openFaceModal = () => {
    if (profilePic) {
      props.setIsFaceModalClose(false);
    }
  };

  return (
    <>
      <div className={`photographer-card${isBlocked ? " is-blocked" : ""}`}>
      <button
        type="button"
        className="photographer-card__avatar-button"
        onClick={openFaceModal}
        aria-label={`Open ${guestName} face list`}
      >
        <img
          src={avatarUrl}
          alt={guestName}
          className="photographer-card__avatar"
        />
        {isBlocked && (
          <Text
            as="span"
            text="Blocked"
            appearance="body-xs-bold"
            className="photographer-card__badge"
            color="white"
          />
        )}
      </button>

      <Box className="photographer-card__name-wrap">
        <Text
          text={guestName}
          appearance="body-m-bold"
          className="photographer-card__name"
        />
      </Box>

      <Box className="photographer-card__details">
        {data?.email && (
          <Box className="photographer-card__detail-row">
            <Mail />
            <Box>
              <Text
                text="EMAIL"
                appearance="body-xs"
                className="photographer-card__detail-label"
                color="primary-grey-60"
              />
              <Text
                text={data.email}
                appearance="body-s"
              />
            </Box>
          </Box>
        )}

        <Box className="photographer-card__detail-row">
          <Phone />
          <Box>
            <Text
              text="PHONE"
              appearance="body-xs"
              className="photographer-card__detail-label"
              color="primary-grey-60"
            />
            <Text
              text={contactNum}
              appearance="body-s"
            // className="photographer-card__detail-value"
            />
          </Box>
        </Box>
      </Box>

      <Box className="photographer-card__actions">
        {isDenied && (
          <Button
            variant="outlined"
            fullWidth
            startIcon={<UserCheck />}
            className="photographer-card__button"
            onClick={() => props?.action && props.action("1", id)}
          >
            Restore
          </Button>
        )}
        {isBlocked ? (
          <Button
            variant="outlined"
            fullWidth
            startIcon={<UserCheck />}
            className="photographer-card__button photographer-card__button--success"
            onClick={() => props?.restoreAction && props.restoreAction(id)}
          >
            Unblock
          </Button>
        ) : (
          <Button
            variant="outlined"
            fullWidth
            startIcon={<Edit2 className="photographer-card__edit-icon" />}
            className="photographer-card__button"
            onClick={() => props?.setIsEditPhotographerModalClose(false)}
          >
            Edit Profile
          </Button>
        )}
        {isBlocked ? (
          <Tooltip label="Edit Profile" position="bottom">
            <IconButton
              aria-label="Edit profile"
              className="photographer-card__icon-action"
              onClick={() => props?.setIsEditPhotographerModalClose(false)}
            >
              <Edit2 className="photographer-card__edit-icon" />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip label="Block" position="bottom">
            <IconButton
              aria-label="Block"
              className="photographer-card__icon-action photographer-card__icon-action--danger"
              onClick={() => setBlockModalClose(false)}
            >
              <UserX />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </div>

      <JdsModal
        size="m"
        header="Are you sure you want to block the photographer?"
        kind="dialog"
        primaryCTA={{
          title: "Okay",
        }}
        secondaryCTA={{
          title: "Cancel",
        }}
        close={isBlockModalClose}
        onClose={() => setBlockModalClose(true)}
        onPrimaryClick={() => {
          props?.blockAction && props.blockAction(id);
          setBlockModalClose(true);
        }}
        onSecondaryClick={() => setBlockModalClose(true)}
        primaryCtaDisabled={props?.isActionLoading}
      />
    </>
  );
}

const PhotoInDiv = ({
  item,
  eventId,
  setLightboxController,
  setModalUsername,
  getFaceListHandler,
  setPreviewImgArr,
  setPage,
  page,
  setClusterId,
  setFaceList,
}) => {
  const [scalingFactor, setScalingFactor] = useState(0);
  const [faceDetection, setFaceDetection] = useState(false);
  const [faceDiv, setFaceDiv] = useState([]);
  const { sendRequest: faceDetectionApi, isLoading: isFaceDetectionLoading } =
    useApiHttp();
  const { sendRequest: downloadRequest } = useApiHttp();

  const faceDetectionHandle = (value) => {
    faceDetectionApi(
      {
        url: `face/show-detected-faces?eventId=${eventId}&mediaId=${value}`,
        method: "GET",
        base: "MEDIA",
      },
      null,
      (data) => {
        setFaceDiv(data?.data);
      }
    );
  };

  const downloadImg = (index = 0, isMultiple = false, fileUrl = "") => {
    const formData = new FormData();
    formData.append("imageUrl", fileUrl);
    formData.append("eventId", eventId);
    return new Promise((resolve, reject) => {
      downloadRequest(
        {
          url: `organizer/download`,
          method: "POST",
          base: "MEDIA",
          formData: true,
          body: formData,
        },
        null,
        (data) => {
          const imageUrl = URL?.createObjectURL(data);
          if (!isMultiple) {
            downloadFile(imageUrl, "image");
            Notifications?.toast?.success("Image Downloaded");
          } else {
            // dispatch(uploadPhotosActions.setUploadCount(index + 1));
            resolve(data); // Resolve the Promise with the imageUrl
          }
        },
        (err, data) => {
          Notifications?.toast?.error({
            id: "download-photos-error",
            title: data?.message,
          });
          reject(err);
        }
      );
    });
  };

  const imgRef = useRef(null);
  return (
    <>
      <img
        ref={imgRef}
        // src={item?.reducedFileSignedPath}
        src={decryptUrl(item?.reducedFileSignedPath)}
        style={
          {
            // height: "auto !important",
            // maxHeight: "80vh !important",
            // maxWidth: "50vw",
            // width: "auto !important",
          }
        }
      />

      <div
        style={{
          position: "absolute",
          bottom: "15px",
          width: "100%",
          // minWidth: "500px",
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          marginTop: "10px",
          whiteSpace: "nowrap",
        }}
      >
        <ActionButton
          label={`${faceDetection ? "Hide" : "Show detected faces"}`}
          kind="secondary"
          appearance="contrast"
          onClick={(e) => {
            e.stopPropagation();
            faceDetectionHandle(item?.mediaId);
            const originalWidth = imgRef?.current?.naturalWidth;
            const originalHeight = imgRef?.current?.naturalHeight;
            const scalingFactor = Math.min(
              imgRef?.current?.offsetWidth
                ? imgRef?.current?.offsetWidth / originalWidth
                : 0,
              imgRef?.current?.offsetHeight
                ? imgRef?.current?.offsetHeight / originalHeight
                : 0
            );
            setScalingFactor(scalingFactor);

            setFaceDetection((pre) => !pre);
          }}
        />
        <ActionButton
          kind="secondary"
          icon={"IcDownload"}
          label="Download"
          appearance="contrast"
          onClick={(e) => {
            // e.stopPropagation();

            downloadImg(undefined, undefined, item?.originalFileSignedPath);
          }}
        />
      </div>
      {faceDiv?.map((divItem) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
            // window.location.reload();
            // document.body.style.overflow = "";
            // document.documentElement.style.overflow = "";
            // // Remove fslightbox applied styles
            // document.body.classList.remove("fslightbox-open");
            // const fslightbox = document.querySelector(".fslightbox-container");
            // if (fslightbox) {
            //   fslightbox.style.overflow = "";
            // }

            const closeBtn = document.querySelector(
              'div.fslightbox-toolbar-button[title="Close"]'
            );
            closeBtn.click();
            // setLightboxController((pre) => {
            //   return {
            //     ...pre,
            //     toggler: false,
            //     slide: 1,
            //   };
            // });
            if (divItem?.clusterId !== item?.clusterId) {
              setPreviewImgArr([]);
              setFaceList([]);
              setClusterId(divItem?.clusterId);
              setPage(0);
              setModalUsername(divItem?.username);
            }
          }}
          key={divItem?.clusterId}
          className="rectangle"
          style={{
            display: faceDetection ? "block" : "none",
            position: "absolute",
            left: divItem?.xcoordinate * scalingFactor,
            top: divItem?.ycoordinate * scalingFactor,
            width: divItem?.imageWidth * scalingFactor,
            height: divItem?.imageHeight * scalingFactor,
            border: "2px solid #00ff00",
            cursor: "pointer",
            borderRadius: "1px",
          }}
        />
      ))}
    </>
  );
};
